import Stack from '@mui/material/Stack'
import * as React from 'react'
import styled from 'styled-components'
import StackContext from '../contexts/stackContext'

const Container = styled.div`
  position: fixed;
  bottom: 0;
  height: 300px;
  width: 100%;
  z-index: 9999;
`

export default function Toasts() {
  const stackContext = React.useContext(StackContext)

  if (!stackContext || !stackContext?.getToasts().length) {
    return null
  }

  return (
    <Container>
      <Stack spacing={2} sx={{ width: '100%', height: '100%', flexDirection: 'column-reverse' }}>
        {stackContext.getToasts()}
      </Stack>
    </Container>
  )
}
